import { defineStore } from 'pinia'
import { Office } from './form'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(duration)
dayjs.extend(relativeTime)

export type Question = { question: string; answer: string }
export type HeaderItem = { title: string; selector: string }
export type Benefit = { title: string; text: string }
export type LinkButton = { title: string; link: string }
export type BlockRule = { rule: 'equals' | 'contains'; value: string }
export type Review = {
	text: string
	name: string
	service: 'google' | 'yelp'
}

export type Recent = {
	vehicle: string
	buyer: string
	img: string
}
export type RGBAColor = { r: string; g: string; b: string; a: number }
export type ProgressbarIcon = {
	icon: 'beetle' | 'fiat'
	colorBody: string
	colorWindows: string
	colorElements: string
}
export type ConfigTheme = {
	variables: Record<string, string | RGBAColor>
	content: {
		[key: string]:
			| string
			| boolean
			| ProgressbarIcon
			| Review[]
			| Record<string, string>[]
			| Record<string, string>
			| undefined
		widgetText: string
		widgetType: 'website' | 'standard' | 'form'
		widgetAppearance: string
		widgetAppearanceMobile: string
		widgetPosition: string
		widgetPositionMobile: string
		headerTitle: string
		headerSubtitle: string
		phone: string
		customScript: string
		carColor: {
			name: string
			img: string
		}
		progressbarIcon?: ProgressbarIcon

		fullName: boolean

		logoHide: boolean
		makeHidden: boolean

		blockList: BlockRule[]

		reviewsShow: boolean
		reviews: Review[]

		questions: Question[]

		benefits: Benefit[]
		congratsButtons: LinkButton[]
		uploadOfferButtons: LinkButton[]
	}
}
export type DriveoLocation = {
	id: number
	name: string
	state: string
	shortcode: string
	dealership_name: string
	main_number: string
	offices?: Office[]
}
export type Config = {
	api_url: string
	token: string

	origin?: string
	redirect_url?: string
	location: DriveoLocation
	email: string
	utm_medium?: string
	utm_source?: string
	utm_campaign?: string
	utm_term?: string
	gtm_token?: string
	theme?: ConfigTheme | string
	logo: string

	years: number[]

	quote_validity: number
}

export const useConfigStore = defineStore({
	id: 'configStore',
	state: () => ({
		config: {} as Config,
	}),

	getters: {
		getConfigContent:
			state =>
			<T>(key: string, fallback: T): T => {
				return ((state.config?.theme as ConfigTheme)?.content?.[key] || fallback) as T
			},

		getQuoteValidityHumanize(state) {
			return dayjs.duration(state.config.quote_validity || 10, 'days').humanize()
		},

		getOffices(state) {
			return (
				state.config?.location?.offices?.filter(
					(o: Office) => !o.is_remote && o.visible && o.published,
				) || []
			)
		},
	},

	actions: {},
})
